import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {RestrictionsResponseData} from "../../framework/bi/restrictions-response.data";

@Component({
    selector: "wbo-bi-view-header",
    templateUrl: "./view-header.component.html",
    styleUrls: ["./view-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewHeaderComponent {
    @Input() showRefresh: boolean = true;

    @Input() restrictions: RestrictionsResponseData;

    @Input() rowsTruncated: number;
    @Input() columnsTruncated: number;

    @Output() refresh: EventEmitter<any> = new EventEmitter<any>();

    get fromDate(): Date {
        return new Date(this.restrictions.filteredStartDate);
    }

    get toDate(): Date {
        return new Date(this.restrictions.filteredEndDate);
    }
}
